import { Component, OnInit,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { callRtlStyle, removeRtlStyle } from 'src/app/globals';
import { SignInDialogComponentComponent } from './components/sign-in-dialog-component/sign-in-dialog-component.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  code: string | null = null;
  state: string | null = null;
  lang: string | null = localStorage.getItem('lang');  

  constructor(
    private translate: TranslateService,
    private router: Router, private route: ActivatedRoute ,private dialog: MatDialog
  ) {
    translate.addLangs(['en', 'ar']);
  }

  ngOnInit() {
    debugger
  
    this.route.queryParams.subscribe(params => {
    this.code = params['code'];  
    this.state = params['state']; 
    if (this.code) {
        this.router.navigate(['/home'], { queryParams: { code: this.code, state: this.state } });
      }
    });
    if (this.lang) {
      this.translate.use(this.lang);
      document.getElementsByTagName('html')[0].lang = this.lang;

      if (this.lang === 'ar') {
        callRtlStyle();
      } else {
        removeRtlStyle();
      }
    } else {
     
      this.translate.use('ar');
      localStorage.setItem('lang', 'ar');
      document.getElementsByTagName('html')[0].lang = 'ar';
      callRtlStyle();
    }
  }

  openDialog(): void {
    this.dialog.open(SignInDialogComponentComponent, {
      data: { userInfo: 'Sample User Data' } // Example of passing data to the dialog
    });
  }
}
